import {message} from '@sail/intl';

export const closeButtonLabel = message({
  id: '@sail/ui.drawer.closeButtonLabel',
  description: 'The label for the close button in a drawer',
  defaultMessage: 'Close',
});

export const stepProgressLabel = message<{step: number; totalSteps: number}>({
  id: '@sail/ui.drawer.stepProgressLabel',
  description: 'The label for the step progress in a drawer',
  defaultMessage: 'Step {step} of {totalSteps}',
});

export const closePreviewButtonLabel = message({
  id: '@sail/ui.drawer.closePreviewButtonLabel',
  description:
    'The label for the button that closes the preview pane in a creation drawer',
  defaultMessage: 'Close preview',
});

export const showPreviewButtonLabel = message({
  id: '@sail/ui.drawer.showPreviewButtonLabel',
  description:
    'The label for the button that opens the preview pane in a creation drawer',
  defaultMessage: 'Show preview',
});

export const bottomSheetTabsAriaLabel = message({
  id: '@sail/ui.drawer.bottomSheetTabsAriaLabel',
  description:
    'The aria-label for the tab list in the bottom sheet of a drawer',
  defaultMessage: 'Drawer sections',
});

export const bottomSheetPreviewTabTitle = message({
  id: '@sail/ui.drawer.bottomSheetPreviewTabTitle',
  description:
    'The title for the preview tab in the bottom sheet of a creation drawer. Preview is a verb.',
  defaultMessage: 'Preview',
});

export const bottomSheetEditTabTitle = message({
  id: '@sail/ui.drawer.bottomSheetEditTabTitle',
  description:
    'The title for the edit tab in the bottom sheet of a creation drawer. Edit is a verb.',
  defaultMessage: 'Edit',
});

export const bottomSheetDefaultTabTitle = message<{number: number}>({
  id: '@sail/ui.drawer.bottomSheetDefaultTabTitle',
  description:
    'The default title for a tab in the bottom sheet of a drawer when no custom title is provided',
  defaultMessage: 'Tab {number}',
});
